import Container from "@/components/atoms/Container";
import PageHeader from "@/components/molecules/PageHeader";
import SowForm, {
  SowProps,
  useSowForm,
} from "@/components/organisms/Sow/Form";
import useMessageProps from "@/hooks/useMessageProps";
import Sow from "@/types/Sow";
import { router } from "@inertiajs/react";
import { useState } from "react";

type Props = SowProps & {
  sow: Sow;
  redirect_props: any;
};

const NewSow = ({ sow, redirect_props, ...rest }: Props) => {
  const form = useSowForm(sow);
  const [loading, setLoading] = useState(false);

  useMessageProps({ redirect_props });

  const onSubmit = (data: any) => {
    router.post(`/sows`, data, {
      onStart: () => setLoading(true),
      onFinish: () => setLoading(false),
    });
  };

  return (
    <Container>
      <PageHeader title="New Sow" />
      <SowForm
        form={form}
        edit={true}
        sow={sow}
        onSubmit={onSubmit}
        data={rest}
        loading={loading}
        mode="create"
        errors={redirect_props?.errors}
      />
    </Container>
  );
};

export default NewSow;
